import React from 'react';
import { ClockIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { Seo } from '../components/ui/Seo';
import { PageHero } from '../components/ui/PageHero';
import { InquiryForm } from '../components/forms/InquiryForm';
import { MapEmbed } from '../components/shared/MapEmbed';
import { IMAGES } from '../data/images';
import { SITE } from '../data/site';
export function Contact() {
  const loc = SITE.location;
  return <>
      <Seo title="Contact HPP Training" description="Call (702) 375-5900 or visit our classroom at Bass Pro Shops, 8200 Dean Martin Dr, Las Vegas, NV 89139." data-id="element-703" data-mp="y0ywxru6rrgv" />
      <PageHero title="Contact Us" sub="Questions about a course, a private lesson or your CCW? We’re here 7 days a week." image={IMAGES.classroom} crumbs={[{
      label: 'Contact'
    }]} data-id="element-704" data-mp="17qqt2qhxosng" />
      <section className="gutter section grid gap-12 bg-mist lg:grid-cols-12" data-id="element-705" data-mp="f9y1vew6sg2l">
        <div className="lg:col-span-7 2xl:col-span-8" data-id="element-706" data-mp="f7v0jypl30ik">
          <InquiryForm title="Send us a message" topicLabel="I’m asking about" topics={['A CCW permit class', 'CCW renewal', 'Defensive training', "Women's training", 'Private training', 'Something else']} submitLabel="Send Message" data-id="element-707" data-mp="aabliwl2ajpk" />
        </div>
        <div className="space-y-6 lg:col-span-5 2xl:col-span-4" data-id="element-708" data-mp="1e7qs3bu6tkjg">
          <a href={SITE.phoneHref} className="group flex items-center gap-5 rounded-[4px] bg-navy p-7" data-id="element-709" data-mp="1e8a98qc0k4wf">
            <PhoneIcon className="h-8 w-8 shrink-0 text-accent-bright" aria-hidden="true" data-id="element-710" data-mp="1j621jlgklt15" />
            <span data-id="element-711" data-mp="mi5m4jwvd3ri">
              <span className="block text-sm text-chrome-300" data-id="element-712" data-mp="minlhpetvy3n">Call or text</span>
              <span className="font-display text-3xl font-semibold text-white group-hover:underline" data-id="element-713" data-mp="qig0okyq92hz">{SITE.phoneDisplay}</span>
            </span>
          </a>
          <div className="rounded-[4px] bg-white p-7 ring-1 ring-navy/10" data-id="element-714" data-mp="10gm10y4vy0kq">
            <h2 className="flex items-center gap-2 font-display text-lg font-semibold uppercase text-navy" data-id="element-715" data-mp="26wej7o1mb44x">
              <ClockIcon className="h-5 w-5 text-accent" aria-hidden="true" data-id="element-716" data-mp="2bv918nrrgonz" /> Hours
            </h2>
            <dl className="mt-4 space-y-2" data-id="element-717" data-mp="1m73nnvt6nicu">
              {SITE.hours.map(h => <div key={h.days} className="flex justify-between gap-4 border-b border-navy/10 pb-2 text-ink" data-id="element-718" data-mp="1h8agsm8eipln">
                  <dt className="font-medium" data-id="element-719" data-mp="1w59osb760kgn">{h.days}</dt>
                  <dd className="text-steel" data-id="element-720" data-mp="1w4rpt6t4bs51">{h.time}</dd>
                </div>)}
            </dl>
          </div>
          <div className="overflow-hidden rounded-[4px] bg-white ring-1 ring-navy/10" data-id="element-721" data-mp="13gvofosltc1x">
            <MapEmbed className="h-72" data-id="element-722" data-mp="13ej5p9f0uxnt" />
            <div className="flex gap-3 p-6" data-id="element-723" data-mp="yike7cyeczj6">
              <MapPinIcon className="mt-0.5 h-5 w-5 shrink-0 text-accent" aria-hidden="true" data-id="element-724" data-mp="yfofhmeq66to" />
              <address className="not-italic text-ink" data-id="element-725" data-mp="1d8rxfuw8amkx">
                <strong className="font-semibold" data-id="element-726" data-mp="18fp49nvd5f59">{loc.venue}</strong>
                <br data-id="element-727" data-mp="kqe52atnvst8" />
                {loc.street}, {loc.city}, {loc.region} {loc.postal}
                <br data-id="element-728" data-mp="frb1yvx8rwnw" />
                <span className="text-steel" data-id="element-729" data-mp="frt6sgxyzj7f">{loc.area}</span>
                <br data-id="element-730" data-mp="fp6zmiezr5pq" />
                <a href={loc.mapLink} target="_blank" rel="noopener noreferrer" className="mt-2 inline-block font-semibold text-navy underline underline-offset-4" data-id="element-731" data-mp="2remvju29nmo9">
                  Get directions
                </a>
              </address>
            </div>
          </div>
        </div>
      </section>
    </>;
}